<template>
  <div class="process-dialog-attribute">
    <el-dialog ref="processAttrDialog" class="process-attribute-dialog process-attribute-draggable-dialog" :visible.sync="attribute.dialogVisible" :close-on-click-modal="false" width="540px" append-to-body :modal="false">
      <el-tabs ref="processBasicCard" v-model="attribute.active" type="border-card" :before-leave="judgeClick">
        <el-tab-pane label="控件交互" name="first">
          <component-interaction-attr ref="componentInteractions" :componentInteraction="attribute.componentInteraction"></component-interaction-attr>
        </el-tab-pane>
        <el-tab-pane label="节点交互" name="second">
          <div class="node-archive">
            <div class="title">中途归档</div>
            <div class="content">
              <div>每一节点完成后均归档<el-switch v-model="attr.allNodeArchiveEnable" :disabled="disabled"></el-switch></div>
              <div>
                <el-select v-model="attr.nodeArchive" :disabled="attr.allNodeArchiveEnable" placeholder="请选择归档节点" multiple collapse-tags>
                  <el-option v-for="node in nodeArchiveOptions" :key="node.id" :label="node.name" :value="node.id"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <p class="tip">说明:通过节点交互的设置,可以在流程的某个节点完成后,对其他的表进行数据操作</p>

          <el-form ref="form" class="box" label-position="left" :inline="true">
            <transition-group name="transition" tag="ul">
              <div class="node-interaction" v-for="(item,index) in attr.interactions" :key="item.id">
                <div class="title">节点交互{{attr.interactions.length - index}}<i class="el-icon-close del-node-interaction" @click="delNodeInteraction(index)"></i></div>
                <div class="content">
                  <el-form-item label="触发节点" label-width="58px" class="odd">
                    <el-select v-model="item.triggerNode" filterable clearable @change="clearConnections(item)">
                      <el-option v-if="!['cancelEvent','endEvent'].some(n=>n===node.type)" v-for="node in definition.process.nodes" :key="node.id" :label="node.name" :value="node.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="触发流转" label-width="58px" class="even">
                    <el-select v-model="item.triggerConnections" filterable multiple collapse-tags :disabled="!item.triggerNode" placeholder="请先选择触发节点" @change="getActionIds($event,item)">
                      <el-option v-show="connection.sourceNodeId === item.triggerNode" v-for="(connection,index) in connections(item.triggerNode)" :key="connection.id" :label="connection.defaultLine?'默认流转':'流转'+index" :value="connection.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="触发条件" label-width="58px" class="expression-item">
                    <div class="calculate" @click="openCalculate(item.expressionText, item)" v-html="expressionShow(item.expressionText)">{{item.expressionText}}</div>
                  </el-form-item>
                  <el-form-item label="目标表" label-width="58px" class="odd">
                    <public-combobox
                      v-model="item.targetTable"
                      :options="processService.formService.options.tables"
                      @change="targetTableChange($event,item)"
                      :placeholder="'请选择目标表'">
                    </public-combobox>
                  </el-form-item>
                  <el-form-item label="比对字段" label-width="58px" class="compare-field">
                    <public-combobox
                      v-model="item.compareField"
                      :optionsList="currentTableOptions(item.sourceTable, 'compareField')"
                      :placeholder="'请选择比对字段'"
                      :computedByLabel="{methods: 'process-dialog-compareField'}">
                    </public-combobox>
                    <el-tooltip class="tooltip" content="选择本流程表中的某个字段作为条件，与目标表中的主键进行比对。" placement="top">
                      <span class="fa fa-question-circle"></span>
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item v-if="formService.schema.tables.length > 1" label="源表单" label-width="58px" class="odd">
                    <el-select v-model="item.sourceTable" filterable clearable @change="sourceTableChange(item)">
                      <el-option v-for="table in sourceTables" :key="table.id" :label="table.name" :value="table.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="dispose-flex">
                    <span>交互字段</span>
                    <span @click="openDialog(item, index)">&nbsp;&nbsp;高级绑定</span>
                  </el-form-item>
                  <el-form-item class="interaction-field" v-for="(el,i) in item.interactionFields" :key="i">
                    <div class="flex">
                      <div class="left">
                        <public-combobox
                          v-model="el.firstField"
                          :optionsList="currentTableOptions(item.sourceTable)"
                          :placeholder="'请选择本表字段'"
                          :computedByLabel="{methods: 'process-dialog-compareField'}"
                          :defaultOptions="[{name: '默认值', id: '默认值', pinyinName: 'morenzhi', pinyinFirstChar: 'mrz'}]"
                          @change="setRelationId($event,el)">
                        </public-combobox>
                      </div>
                      <div class="middle">
                        <public-combobox
                          v-model="el.secondField"
                          :options="item.columns"
                          :disabled="{key: 'process-dialog-second-field', interactionFields: item.interactionFields, secondField: el.secondField}"
                          :placeholder="'请选择目标表字段'">
                        </public-combobox>
                      </div>
                      <div class="right">
                        <i class="el-icon-minus delField" @click="delField(item,i)"></i>
                      </div>
                    </div>
                    <el-input class="default-value" v-if="el.firstField==='默认值'" v-model="el.defaultValue"></el-input>
                  </el-form-item>
                  <i class="el-icon-plus add-field" @click="addField(item)">添加交互字段</i>
                </div>
              </div>
            </transition-group>
          </el-form>

          <i class="el-icon-plus add-node-interaction" @click="addNodeInteraction"> 添加节点交互</i>
        </el-tab-pane>
        <el-tab-pane label="接口交互" name="third">接口交互</el-tab-pane>
        <el-tab-pane label="操作校验" name="fourth">
          <operation-verification ref="formValidates" :formValidates="attribute.formValidates" :type="'process'" :processService="processService" :definition="definition"></operation-verification>
        </el-tab-pane>
        <el-tab-pane label="其他设置" name="fifth">
          <div class="temporary-storage">
           <h1 class="formScreen">显示大小</h1>
            <el-radio-group v-model="attribute.formScreen">
              <el-radio label="full">全屏</el-radio>
              <el-radio label="middle">(大)600x800</el-radio>
              <el-radio label="small">(中)400x600</el-radio>
            </el-radio-group>
          </div>
          <div class="temporary-storage">
            <h1>流程暂存</h1>
            <el-tooltip class="tooltip" content="开启后，流程每个节点在处理时都可以进行暂存。再次处理流程时系统会自动加载已暂存的数据。" placement="top">
              <span class="fa fa-question-circle"></span>
            </el-tooltip>
            <el-switch v-model="attr.temporaryStorageEnable"></el-switch>
          </div>
          <div class="process-category">
            <h1>流程分类</h1>
             <el-select v-model="definition.category" placeholder="请选择">
              <el-option
                v-for="item in categories"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="process-title">
            <div class="process-title-content">
              <h1>流程信息</h1>
              <el-tooltip class="tooltip" content="使用固定文本和数据列结合，可以生成动态的流程概要。概要信息会被应用到流程列表中。" placement="top">
                <span class="fa fa-question-circle"></span>
              </el-tooltip>
              <div class="theme"
                   ref="processTitle"
                   @blur="saveCursor"
                   v-html="processTitle"
                   contenteditable></div>
            </div>

            <div class="process-title-data">
              <h1>数据列</h1>
              <el-menu>
                <el-menu-item
                  index="processName"
                  name="流程名称"
                  @click="addParam('processName','流程名称')">[流程名称]
                </el-menu-item>
                <el-menu-item
                  index="startUser"
                  name="发起人"
                  @click="addParam('startUser','发起人')">[发起人]
                </el-menu-item>
                <el-menu-item
                  v-for="(column,index) in getTableColumns"
                  :key="index"
                  :index="column.id"
                  :name="column.name"
                  @click="addParam(column.id,column.name)">{{column.name}}
                </el-menu-item>
              </el-menu>
            </div>
          </div>
         <div class="process-app upload-content">
           <el-form>
               <el-form-item label="开启app">
                    <el-tooltip content="开启后，可在移动端使用" placement="top" class="tooltip">
                    <span class="fa fa-question-circle"></span>
                </el-tooltip>
                <el-switch v-model="definition.appSwitch"/>
               </el-form-item>
             <app-model :model="model" :type="'流程'"></app-model>
           </el-form>
         </div>
         <div class="turn-on-reassign">转交 <el-switch v-model="definition.turnOnReassign"></el-switch></div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="btns">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <advanced-binding :data="advancedBindingData" @saveFields="saveFields"></advanced-binding>
  </div>
</template>

<script>
import ComponentInteractionAttr from '@/components/shared/component-interaction-attr.vue'
import OperationVerification from '@/components/shared/operation-verification.vue'
import AppModel from '../../shared/openApp/app-model.vue'
import { calculateMixin } from '@/components/form/components/mixins'
import { dataSourceReport } from '../../shared/designMixins/mixins'
import {ColumnComponent} from '@/store/form/component'
import publicCombobox from '@/components/public/public-combobox.vue'
import {UUID} from '../../../plugins/common'
import move from '@/plugins/move'
import advancedBinding from '../../public/advanced-binding.vue'
export default {
  name: 'ProcessAttribute',
  props: [ 'attribute', 'definition' ],
  mixins: [ calculateMixin, dataSourceReport ],
  inject: [ 'processService', 'formService' ],
  components: {
    ComponentInteractionAttr,
    OperationVerification,
    AppModel,
    publicCombobox,
    advancedBinding
  },
  data () {
    // 控件交互，源表单选项
    let sourceTables = []
    let dataSourceTable = this.$_.cloneDeep(this.formService.schema.tables) || []
    sourceTables = dataSourceTable.map((t, index) => {
      // 如果存在关联，从主键判断主表；否则只有一张表就是流程的就是主表
      if ((this.formService.schema.relations && this.formService.schema.relations[0] && t.tableId === this.formService.schema.relations[0].primaryTable) || (this.formService.schema.relations.length === 0 && t.name === '流程')) {
        t.name = '主表单'
        t.mainFlag = true
        t.tableId = 'mainTableId'
      }
      return {name: t.name, id: t.tableId, isMainTable: t.mainFlag || ''}
    })
    return {
      attr: this.$_.cloneDeep(this.definition.process.attribute),
      cacheRange: '',
      disabled: false,
      categories: [],
      formScreen: 'full',
      model: this.$_.clone(this.definition),
      sourceTables: sourceTables,
      dragDom: null,
      startMove: false,
      advancedBindingData: {
        visable: false,
        title: '节点交互',
        selfTable: [],
        targetTable: [],
        interactionFields: [],
        index: -1,
        showTableName: false
      }
    }
  },
  mounted () {
    this.loadCategory()
    this.loadColumns()
    if (!this.nodeArchiveOptions.length) {
      this.definition.process.attribute.allNodeArchiveEnable = this.attr.allNodeArchiveEnable = false
      this.disabled = true
    }
    this.$nextTick(() => {
      if (this.$refs.processAttrDialog && this.$refs.processAttrDialog.$el && this.$refs.processAttrDialog.$el.childNodes) {
        if (this.$refs.processBasicCard && this.$refs.processBasicCard.$el && this.$refs.processBasicCard.$el.firstChild) {
          let self = this
          this.dragDom = move({
            drag: this.$refs.processBasicCard.$el.firstChild,
            dom: this.$refs.processAttrDialog.$el.childNodes[0],
            end (e, distance) {
              if (Math.abs(distance.x) > 8 || Math.abs(distance.y) > 8) {
                if (!self.startMove) {
                  self.startMove = true
                }
              }
            }
          })
        }
      }
    })
  },
  methods: {
    loadColumns () {
      this.attr.interactions.forEach(interaction => {
        if (interaction.targetTable && !interaction.columns.length) {
          this.processService.formService.loadTable(interaction.targetTable).then((columns) => {
            interaction.columns = columns
          })
        }
        if (!('sourceTable' in interaction) || !interaction.sourceTable) {
          interaction.sourceTable = 'mainTableId'
        }
        // id用来单独标识每一个dom节点, 否则vue动画不会生效, 保存时再删掉
        if (!('id' in interaction) || !interaction.id) {
          interaction.id = UUID.create()
        }
      })
    },
    targetTableChange (value, item) {
      item.columns = []
      item.interactionFields = [{firstField: '', secondField: '', relationId: '', defaultValue: ''}]
      if (value) {
        this.processService.formService.loadTable(value).then((columns) => {
          this.$set(item, 'columns', columns)
        })
      }
    },
    // 源表单更改时，清除交互信息
    sourceTableChange (item) {
      item.compareField = ''
      item.interactionFields = [{firstField: '', secondField: '', relationId: '', defaultValue: ''}]
    },
    addField (item) {
      item.interactionFields.push({firstField: '', secondField: '', relationId: '', defaultValue: ''})
    },
    delField (item, i) {
      if (item.interactionFields.length !== 1) {
        item.interactionFields.splice(i, 1)
      } else {
        item.interactionFields = [{firstField: '', secondField: '', relationId: '', defaultValue: ''}]
      }
    },
    // 添加节点交互
    addNodeInteraction () {
      if (this.attr.interactions.unshift) {
        this.attr.interactions.unshift({
          id: UUID.create(),
          columns: [],
          triggerNode: '',
          triggerConnections: [],
          actionIds: [],
          expressionText: '',
          targetTable: '',
          compareField: '',
          sourceTable: 'mainTableId',
          interactionFields: [{firstField: '', secondField: '', relationId: '', defaultValue: ''}]
        })
      } else {
        this.attr.interactions = [{
          id: UUID.create(),
          columns: [],
          triggerNode: '',
          triggerConnections: [],
          expressionText: '',
          actionIds: [],
          targetTable: '',
          compareField: '',
          interactionFields: [{firstField: '', secondField: '', relationId: '', defaultValue: ''}]
        }]
      }
    },
    openCalculate (expressionText, interaction) {
      if (interaction.triggerNode) {
        this.calculatePopup(expressionText, interaction)
      } else {
        this.$message.info('请选择触发节点')
      }
    },
    calculatePopup (expressionText, interaction) {
      this.$Popup.calculation({
        parameter: {
          expression: expressionText,
          dataSource: this.nodeDataSource(interaction.triggerNode),
          dataSourceEnable: true,
          dataSourceReports: this.processService.formService.options.dataSourceReports
        },
        width: '1000px',
        calculationType: 'java'
      }).then((data) => {
        if (data.action === 'confirm') {
          this.$set(interaction, 'expressionText', data.value)
        }
      })
    },
    nodeDataSource (nodeId) {
      let formIds = []
      let dataSource = []
      // 通过nodeId找到节点以及当前节点前的节点
      let previousNode = this.definition.process.getpreviousNode(nodeId)
      this.definition.process.nodes.forEach(m => {
        if (previousNode.includes(m.id)) { formIds.push(m.formId) }
      })
      // 遍历全部之前节点的formIs取控件
      formIds && formIds.forEach(m => {
        let columns = []
        let form = this.processService.formService.component.children.find(n => n.id === m)
        form.archivedChildren.filter(m => m instanceof ColumnComponent).forEach(m => {
          columns.push({'id': m.archive.columnId, 'name': m.name, 'dataType': m.archive.dataType})
          if (m.properties.archived &&
              m.properties.archived.hasOwnProperty('showColumnId') &&
              m.properties.archived.showColumnId !== '') {
            columns.push({'id': m.properties.archived.showColumnId, 'name': `${m.name}内容`, 'dataType': m.archive.dataType})
          }
        })
        dataSource.push({'id': form.id, 'name': form.name, columns: columns, 'type': 'OneToOne'})
      })
      return dataSource
    },
    expressionShow (expressionText) {
      if (expressionText) {
        return this.expressionToWithCode(expressionText)
      }
    },
    clearConnections (connections) {
      connections.triggerConnections = []
    },
    delNodeInteraction (index) {
      this.attr.interactions.splice(index, 1)
    },
    setRelationId (value, el) {
      el.defaultValue = ''
      let component = this.processService.formService.getComponents().find(n => n.archive.columnId === value)
      if (component) {
        let parentComponent = this.processService.formService.getParentComponent(component)
        if (parentComponent && parentComponent.componentType === 'rc-table') {
          el.relationId = parentComponent.archive.relationId
        } else {
          el.relationId = ''
        }
      }
    },
    loadCategory () {
      this.$axios.get('/process-api/processes/categorys').then(res => {
        this.categories = res.data
      })
    },
    saveCursor () {
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.cacheRange = sel.getRangeAt(0)
        this.cacheRange.anchorNode = sel.anchorNode
        this.cacheRange.anchorOffset = sel.anchorOffset
        this.cacheRange.focusNode = sel.focusNode
        this.cacheRange.focusOffset = sel.focusOffset
      }
    },
    addParam (id, name) {
      if (!this.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.cacheRange)

      let html = `&nbsp;<code contenteditable='false' dataId=${id} name=${name}>${name}</code>&nbsp;`
      // 替换选中的内容
      document.execCommand('insertHTML', false, html)
      this.selectParam(this.$refs.processTitle)
    },
    selectParam (selector) {
      selector.focus()
    },
    getTemplateString (templateString) {
      templateString && templateString.match(/<code(.+?)<\/code>/g) && templateString.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataId = el.match(/dataid="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = el.replace(el, '${' + dataId.slice(8, dataId.length - 1) + ',' + name.slice(6, name.length - 1) + '}')
        templateString = templateString.replace(el, newstr).replace(/&nbsp;/g, '')
      })
      return templateString
    },
    templateToWithCode (template) {
      template.match(/\$\{(.+?)\}/g) && template.match(/\$\{(.+?)\}/g).map((el) => {
        let dataId = el.replace(/[${}]/g, '').split(',')[0]
        let name = el.replace(/[${}]/g, '').split(',')[1]
        let code = `&nbsp;<code contenteditable='false' dataId=${dataId} name=${name}>${name}</code>&nbsp;`
        template = template.replace(el, code)
      })
      return template
    },
    validate () {
      // 节点交互校验
      let interactions = this.attr.interactions
      interactions.forEach(m => {
        if (m.actionIds instanceof Array) {
          m.actionIds = JSON.stringify(m.actionIds)
        }
      })
      for (let i = 0, length = interactions.length; i < length; i++) {
        if (!interactions[i].triggerNode || !interactions[i].targetTable || !interactions[i].compareField) {
          return '[节点交互]触发节点、目标表、对比字段必填'
        }
        let interactionFields = interactions[i].interactionFields
        for (let j = 0; j < interactionFields.length; j++) {
          if (!interactionFields[j].firstField || !interactionFields[j].secondField) {
            return '[节点交互]交互字段必填'
          }
        }
      }
      return ''
    },
    // 控件交互校验
    componentInteractionsValidate () {
      return Promise.all(this.$refs.componentInteractions.validate())
    },
    formValidatesValidate () {
      return Promise.all(this.$refs.formValidates.validate())
    },
    save () {
      this.definition.appIcon = this.model.appIcon
      this.formValidatesValidate()
        .then(() => this.componentInteractionsValidate())
        .then(() => {
          let message = this.validate()
          if (!message) {
            this.attr.processTitle = this.getTemplateString(this.$refs.processTitle && this.$refs.processTitle.innerHTML)
            // 倒序存储
            this.attr.interactions && this.attr.interactions.reverse()
            this.attribute.componentInteraction.reverse()
            // 手动加的id去掉
            this.attr.interactions.forEach(m => m.id && delete m.id)
            let componentInteraction = this.$_.cloneDeep(this.attribute.componentInteraction)
            componentInteraction.forEach(m => {
              // 控件交互每项本来无id, 为了vue区分手动加了, 保存时删除.
              m.id && delete m.id
              m.conforms.forEach(n => {
                if (n.changeComponent) { n.changeComponent = n.changeComponent.join(',') }
              })
              m.noConforms.forEach(n => {
                if (n.changeComponent) { n.changeComponent = n.changeComponent.join(',') }
              })
            })
            this.processService.formService.component.properties.componentInteraction = componentInteraction

            this.attribute.formValidates.forEach(m => {
              m.operationType = ''
            })
            this.processService.formService.component.formValidates = this.attribute.formValidates
            this.processService.formService.component.properties.formScreen = this.attribute.formScreen
            this.definition.process.attribute = this.attr
            this.attribute.dialogVisible = false
          } else {
            this.$message.error(message)
          }
        }).catch(() => {
        })
    },
    cancel () {
      this.attribute.dialogVisible = false
      this.attribute.formValidates.forEach(m => {
        m.operationType = ''
      })
    },
    getActionIds (value, item) {
      item.actionIds = []
      this.connections(item.triggerNode).filter(n => value.includes(n.id)).forEach(m => {
        item.actionIds.push({[m.id]: m.actionId})
      })
      item.actionIds = JSON.stringify(item.actionIds)
    },
    judgeClick () {
      if (this.startMove) {
        this.startMove = false
        return false
      }
    },
    openDialog (item, index) {
      if (!item.targetTable) return this.$message.warning('请选择目标表')
      this.advancedBindingData.visable = true
      // 本表字段
      // 默认值：[{name: '默认值', id: '默认值', pinyinName: 'morenzhi', pinyinFirstChar: 'mrz'}]
      let table = this.currentTableOptions(item.sourceTable)
      let columns = []
      table && table.length > 0 && table.forEach(t => {
        let tableColumns = this.$_.cloneDeep(t.columns)
        tableColumns && tableColumns.forEach(c => (c.tableName = t.name))
        if (t.columns) columns = columns.concat(tableColumns)
      })
      this.advancedBindingData.selfTable = columns
      // 目标表字段
      this.advancedBindingData.targetTable = item.columns || []
      // 所选字段
      this.advancedBindingData.selectedFields = this.$_.cloneDeep(item.interactionFields)
      // 当前控件交互的id
      this.advancedBindingData.index = index
      // 只有一个表的时候不展示表名
      this.advancedBindingData.showTableName = table.length > 1
    },
    saveFields (data) {
      let result = this.$_.cloneDeep(data)
      // 给每一项设置 relationId
      result && result.length && result.forEach(c => this.setRelationId(c.firstField, c))
      this.advancedBindingData.index !== -1 && this.$set(this.attr.interactions[this.advancedBindingData.index], 'interactionFields', result)
    }
  },
  computed: {
    connections (chooseNodeId) {
      let _this = this
      return function (chooseNodeId) {
        if (!_this.definition.process.connections) return null
        return _this.definition.process.connections.filter(item => item.sourceNodeId === chooseNodeId)
      }
    },
    allComponent () {
      return this.processService.formService.getAllComponent()
    },
    // 中途归档节点选项
    nodeArchiveOptions () {
      let endEventNode = this.definition.process.nodes.find(node => node.type === 'endEvent')
      let line = this.definition.process.connections.find(line => line.targetNodeId === endEventNode.id)
      return this.definition.process.nodes.filter(node => node.type === 'userTask').filter(node => node.id !== line.sourceNodeId)
    },
    processTitle () {
      if (this.attr.processTitle) {
        return this.templateToWithCode(this.attr.processTitle)
      }
    },
    getTableColumns () {
      let tableId = this.processService.formService.component.archive.tableId
      let filter = ['Id', 'IsDelete', 'CreatedUser', 'CreatedTime', 'LastModifiedUser', 'LastModifiedTime', 'state']
      return this.processService.formService.schema.tables
        .find(n => n.tableId === tableId).columns
        .filter(column => !filter.some(n => n === column.columnName))
    },
    currentTableOptions (sourceTableId, type) {
      return function (sourceTableId, type) {
        let mainTableArray = []
        if (sourceTableId === 'mainTableId') {
          // 主表时比对和交互字段只包含主表字段
          mainTableArray = this.processService.formService.schema.tables.filter(t => {
            if ((this.formService.schema.relations && this.formService.schema.relations[0] && t.tableId === this.formService.schema.relations[0].primaryTable) || (this.formService.schema.relations.length === 0)) {
              return true
            }
          })
        } else if (type === 'compareField') {
          // 比对字段时只含当前表字段
          mainTableArray = this.processService.formService.schema.tables.filter(t => {
            if (t.tableId === sourceTableId) {
              return true
            }
          })
        } else {
          // 子表时交互字段返回子表和主表的字段
          mainTableArray = this.processService.formService.schema.tables.filter(t => {
            if ((this.formService.schema.relations && this.formService.schema.relations[0] && t.tableId === this.formService.schema.relations[0].primaryTable) || (this.formService.schema.relations.length === 0 && t.name === '流程') || t.tableId === sourceTableId) {
              return true
            }
          })
        }
        return mainTableArray
      }
    }
  },
  watch: {
    'attr.nodeArchive' () {
      if (this.attr.hasOwnProperty('nodeArchiveString')) {
        delete this.attr.nodeArchiveString
      }
    }
  },
  beforeDestroy () {
    this.dragDom && this.dragDom.removeEventListener('mousedown', () => {})
  }
}
</script>

<style lang="scss">
  .process-attribute-dialog {
    .el-dialog {
      .el-dialog__header {
        background: inherit !important;
        padding: 0 !important;
        .el-dialog__headerbtn {
          z-index: 10;
        }
      }
      .el-dialog__body {
        padding: 0;
        .tooltip {
          margin-left: 16px;
          color: #409EFF;
        }
        .el-tabs__content {
         overflow: visible;
        }
        .el-tabs {
          border: 0;
          box-shadow: none;
          .el-tabs__nav {
            margin-left: 10px;
            #tab-first, #tab-second, #tab-third,#tab-fourth {
              position: relative;
              &::after {
                 content: "";
                 display: inline-block;
                 width: 1px;
                 height: 20px;
                 position: absolute;
                 top: 12px;
                 right: 1px;
                 background: #D2E0F4;
              }
            }
          }
          .el-tabs__header {
            background-color: #edeeee;
            border: 0;
            .el-tabs__item {
              height: 44px;
              line-height: 44px;
              color: #1A1A1A;
            }
            .is-active {
              background-color: inherit;
              border-right-color: #edeeee;
              border-left-color: #edeeee;
              border-bottom-width: 2px;
              border-bottom-color: #409EFF;
              color: #409EFF;
            }
            div, span, p {
              user-select: none;
            }
          }
          .el-tabs__content {
            padding-left: 15px;
            padding-right: 15px;
            #pane-second {
              .node-archive {
                margin-bottom: 10px;
                border: solid 1px #DBDBDB;
                border-radius: 4px;
                .title {
                  height: 31px;
                  line-height: 31px;
                  background-color: var(--light-9, #EBF5FF);
                  padding-left: 10px;
                  color: #232323;
                }
                .content {
                  padding: 10px;
                  >div {
                    height: 30px;
                    line-height: 30px;
                    color: #A0A0A0;
                    font-size: 12px;
                    .el-switch {
                      margin-left: 28px;
                    }
                    .el-select {
                      width: 100%;
                    }
                  }
                }
              }
              .box.el-form {
                max-height: 400px;
                overflow-y: auto;
                .interaction-field {
                  width: 100%;
                  .el-form-item__content {
                    .flex {
                      display: flex;
                      .el-select {
                        margin-right: 20px;
                        .el-input input {
                          width: 180px;
                        }
                      }
                    }
                  }
                }
                .el-form-item {
                  margin-bottom: 10px;
                  line-height: 28px;
                  margin-right: 0px;
                  position: relative;
                  &.dispose-flex {
                    display: block;
                    width: 100%;
                    .el-form-item__content {
                      & > span {
                        font-size: 12px;
                        color: #232323;
                        cursor: pointer;
                        &:last-child {
                          color: #a8a8a8;
                        }
                      }
                    }
                  }
                  &.odd{
                    width: 220px;
                    margin-right: 10px;
                  }

                  &.even{
                    width: 232px;
                    .el-form-item__content .el-input input{
                      width: 174px;
                    }
                  }
                  &.compare-field{
                    width: 242px;
                    .el-form-item__content .el-input input{
                      width: 174px;
                    }
                    .el-tooltip {
                      position: absolute;
                      right: -26px;
                      top: 8px;
                      color: #c0c2c1;
                      margin-left: 10px;
                      margin-right: 0;
                      &:hover{
                        color: #409EFF;
                      }
                    }
                  }

                  .el-form-item__label {
                    padding-right: 10px;
                    font-size: 12px;
                    color: #2C2C2C;
                  }
                  &.expression-item {
                    height: 28px;
                    margin-bottom: 10px;
                  }
                }
              }
              .node-interaction {
                margin-bottom: 10px;
                border: solid 1px #DBDBDB;
                border-radius: 4px;
                overflow: hidden;
                .el-select .el-input input {
                  width: 150px;
                  height: 30px;
                }
                .title {
                  height: 31px;
                  line-height: 31px;
                  background-color: #EBF5FF;
                  padding-left: 10px;
                  color: #232323;
                  &:hover .del-node-interaction {
                    display:inline;
                   }
                  .del-node-interaction {
                    display: none;
                    float: right;
                    color: #606266;
                    line-height: 28px;
                    margin-right: 10px;
                    font-size: 14px;
                    cursor: pointer;
                  }
                }
                .content {
                  padding: 10px;
                  .add-field {
                    display: block;
                    text-align: center;
                    color: rgb(61, 66, 71);
                    font-size: 12px;
                    line-height: 28px;
                    cursor: pointer;
                    &:hover {
                      color: #54ABF1;
                    }
                    &:active{
                      color: #388DD2
                    }
                  }
                }
                .calculate {
                  width: 408px;
                  border-radius: 4px;
                  border: 1px solid #dcdfe6;
                  height: 28px;
                  padding-left: 15px;
                  background: #f0f2f5;
                  overflow-y: auto;
                }
              }

              .tip {
                color: #A0A0A0;
                font-size: 12px;
                margin-bottom: 10px;
              }
              .add-node-interaction {
                display: block;
                width: 103px;
                color: #409EFF;
                cursor: pointer;
                margin:0 auto;
                margin-top: 10px;
                &:active{
                 color: #388DD2
                }
              }
              .delField {
                display: none;
                float: right;
                color: #409EFF;
                line-height: 28px;
                font-size: 12px;
                cursor: pointer;
              }
              .default-value {
                width: 384px;
                margin-bottom: 8px;
                margin-top: 4px;
              }
              .interaction-field:hover .delField {
                display: inline;
              }
            }
            #pane-fifth {
              h1 {
                display: inline;
                color: #2C2C2C;
                font-size: 12px;
                font-weight:400;
              }
              .el-radio-group {
                margin-left: 10px;
                .el-radio__inner {
                  border-radius: 0;
                }

                .el-radio.is-checked {
                  span.el-radio__label {
                    color: #606266;
                  }

                  span.el-radio__input {
                    width: 14px;
                    height: 16px;
                    display: inline-block;
                    background: url('../../form/componentAttr/assets/select.png') no-repeat;
                    background-size: 14px;

                    .el-radio__inner {
                      display: none;
                    }
                  }
                }
              }
              .temporary-storage,.process-title-content, .process-title-data {
                margin-bottom: 12px;
              }
              .temporary-storage {
                margin-bottom: 12px;
                .el-switch {
                  margin-left: 16px;
                }
              }
              .process-category {
                  margin-bottom: 12px;
              }
              .process-title {
                overflow: hidden;
                .process-title-content {
                  float: left;
                  margin-right: 34px;
                  .theme {
                    overflow-y: auto;
                    outline: none;
                    border: 1px solid #e4e7ed;
                    border-radius: 4px;
                    padding: 2px 10px;
                    width: 269px;
                    height: 200px;
                    margin-top: 10px;
                    line-height: 20px;
                    &:empty:before{
                      content: '{{流程名称}}-{{发起人}}';
                      color: gray;
                    }
                    code {
                      padding: 2px 4px;
                      font-size: 90%;
                      color: #c7254e;
                      background-color: #f9f2f4;
                      border-radius: 4px;
                    }
                  }
                }
                .process-title-data {
                  float: left;
                  .el-menu {
                    width: 177px;
                    height: 200px;
                    margin-top: 10px;
                    border: 1px solid #e4e7ed;
                    border-radius: 4px;
                    overflow-y: auto;
                    .el-menu-item {
                      height: 30px;
                      line-height: 30px;
                    }
                  }
                }
              }
              .process-app {
                .tooltip {
                  color: #c2c3c4;

                  &:hover {
                    color: #409EFF;
                  }
                }
                .el-switch {
                  margin-left: 15px;
                }
              }
              .turn-on-reassign {
                .el-switch {
                  margin-left: 110px;
                }
              }
              .upload-content {
                margin-bottom: 40px;
              }
            }
          }
        }
      }
      .el-dialog__footer {
        .btns {
          text-align: center;
          margin-top: 20px;
          button {
            width: 106px;
            &:nth-child(2){
              margin-left: 50px;
            }
          }
        }
      }
      /*控件交互,数据联动,操作校验的动画效果样式*/
      .transition-enter{
        transform: translateY(-150px);
      }
      .transition-leave-to{
        opacity: 0;
      }
      .transition-enter-active, .transition-leave-active{
        transition: all .3s ease-out;
      }
      .transition-leave-active{
        position: absolute;
      }
      .transition-move {
        transition: transform .3s;
      }
    }
  }
  .process-attribute-draggable-dialog {
    overflow: hidden !important;
    .el-dialog {
      position: absolute;
      // 修改style属性
      margin: 0!important;
      padding: 0;
      left: calc(50% - 270px);
      top: calc(50% - 330px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-dialog-attribute.vue